module.exports = __webpack_public_path__ + "static/media/economy.64f26451.png";